import { render } from "./CabeceraComponentBack.vue?vue&type=template&id=1b255b2e&scoped=true"
import script from "./CabeceraComponentBack.vue?vue&type=script&lang=js"
export * from "./CabeceraComponentBack.vue?vue&type=script&lang=js"

import "./CabeceraComponentBack.vue?vue&type=style&index=0&id=1b255b2e&scoped=true&lang=css"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b255b2e"]])

export default __exports__